<template>
  <div>
    <!-- Opciones Avanzadas -->
    <b-card
      v-if="advanced_settings"
      header-tag="header"
      class="card-options mt-2"
    >
      <template #header>
        <div class="d-flex justify-content-center align-items-center">
          <h4 class="flex-grow-1 text-center m-0">
            {{ $t("reusable.aiComponent.advancedOptions") }}
          </h4>
          <b-icon
            icon="x"
            scale="1.2"
            class="ml-auto icon-settings"
            @click="advancedSettings"
            v-b-tooltip.left.v-secondary.noninteractive="
              $t('reusable.aiComponent.closeAdvancedOptions')
            "
          ></b-icon>
        </div>
      </template>
      <!-- Body de la Tarjeta -->
      <b-card-body class="body-card-container">
        <!-- Temperatura -->
        <div class="mt-0">
          <div class="text-left">
            <div class="container-options-advanced">
              <span>{{ $t("reusable.aiComponent.temperature") }}: </span>
              <b-icon
                icon="info-circle-fill"
                scale="1"
                variant="primary"
                v-b-tooltip.hover.v-secondary.left="
                  $t('reusable.aiComponent.temperatureTooltip')
                "
              >
              </b-icon>
            </div>
            <b-form-input
              type="range"
              min="0"
              max="1"
              step="0.1"
              v-model="localTemperature"
              id="temperatureRange"
              class="mb-0 pb-0 custom-range"
              :style="temperatureStyle"
              @input="updateTemperature"
            >
            </b-form-input>
          </div>
        </div>
        <!-- Tokens Maximos -->
        <div class="mt-0">
          <div class="text-left">
            <div class="container-options-advanced">
              <span>{{ $t("reusable.aiComponent.tokensAmount") }}: </span>
              <b-icon
                icon="info-circle-fill"
                scale="1"
                variant="primary"
                v-b-tooltip.hover.v-secondary.left="
                  $t('reusable.aiComponent.tokensTooltip')
                "
              >
              </b-icon>
            </div>
            <b-form-input
              type="range"
              min="150"
              max="600"
              v-model="localTokens"
              id="tokensRange"
              class="mb-0 pb-0 custom-range"
              :style="tokensStyle"
              @input="updateTokens"
            >
            </b-form-input>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "AdvancedOptions",
  components: {},
  props: {
    advanced_settings: {
      type: Boolean,
      default: false,
    },
    temperature_value: {
      type: Number,
      default: 0.5,
    },
    tokens_value: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      localTemperature: this.temperature_value,
      localTokens: this.tokens_value,
    };
  },
  computed: {
    // Calcula el color de la barra de tokens de forma gradual
    tokensStyle() {
      const min = 150;
      const max = 600;
      const value = this.localTokens;
      const percentage = ((value - min) / (max - min)) * 100;

      // Color gradual de azul claro (#72b6ff) a azul oscuro (#003267)
      const startColor = { r: 114, g: 182, b: 255 }; // #72b6ff
      const endColor = { r: 0, g: 50, b: 103 }; // #003267

      const r = Math.round(
        startColor.r + (endColor.r - startColor.r) * (percentage / 100)
      );
      const g = Math.round(
        startColor.g + (endColor.g - startColor.g) * (percentage / 100)
      );
      const b = Math.round(
        startColor.b + (endColor.b - startColor.b) * (percentage / 100)
      );

      return {
        "--track-color": `rgb(${r}, ${g}, ${b})`,
      };
    },
    // Calcula el color de la barra de temperatura de forma gradual
    temperatureStyle() {
      const min = 0;
      const max = 1;
      const value = this.localTemperature;
      const percentage = ((value - min) / (max - min)) * 100;

      // Color gradual de azul claro (#72b6ff) a azul oscuro (#003267)
      const startColor = { r: 114, g: 182, b: 255 }; // #72b6ff
      const endColor = { r: 0, g: 50, b: 103 }; // #003267

      const r = Math.round(
        startColor.r + (endColor.r - startColor.r) * (percentage / 100)
      );
      const g = Math.round(
        startColor.g + (endColor.g - startColor.g) * (percentage / 100)
      );
      const b = Math.round(
        startColor.b + (endColor.b - startColor.b) * (percentage / 100)
      );

      return {
        "--track-color": `rgb(${r}, ${g}, ${b})`,
      };
    },
  },
  methods: {
    advancedSettings() {
      // Emitir evento al padre en lugar de modificar la prop
      this.$emit("close");
    },
    updateTemperature() {
      this.$emit("update:temperature_value", parseFloat(this.localTemperature));
    },
    updateTokens() {
      this.$emit("update:tokens_value", parseInt(this.localTokens));
    },
  },
  watch: {
    temperature_value(newVal) {
      this.localTemperature = newVal;
    },
    tokens_value(newVal) {
      this.localTokens = newVal;
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.card-options {
  font-family: var(--kl-font-family);
  color: var(--kl-text-body);
  background-color: var(--kl-card-bg);
  border: 1px solid var(--kl-card-border);
  box-shadow: var(--kl-card-shadow);
}
.card-options >>> .card-header {
  padding: var(--kl-space-2) var(--kl-space-3);
  background-color: var(--kl-color-accent-soft);
  border-bottom: 1px solid var(--kl-card-border);
}
.card-options >>> .card-header h4 {
  font-size: var(--kl-fs-title-sm);
  font-weight: var(--kl-fw-semibold);
  color: var(--kl-color-accent);
}
.card-options >>> .card-body {
  padding: 2px;
  min-height: 100%;
}
.icon-settings {
  cursor: pointer;
  color: var(--kl-color-accent);
}
.body-card-container {
  max-height: 75vh;
  overflow-y: auto;
}
.container-options-advanced {
  display: flex;
  justify-content: space-between;
}
/* Barra del input con color dinámico - Webkit (Chrome, Safari, Edge) */
.custom-range::-webkit-slider-runnable-track {
  height: 6px;
  border-radius: 5px;
  background-color: var(--track-color, gray);
  transition: background-color 0.15s ease;
}

/* Barra del input con color dinámico - Firefox */
.custom-range::-moz-range-track {
  height: 6px;
  border-radius: 5px;
  background-color: var(--track-color, gray);
  transition: background-color 0.15s ease;
}

/* Puntero del Input Range - Webkit */
.custom-range::-webkit-slider-thumb {
  height: 16px;
  width: 16px;
  background: white;
  border: 1px solid #00000073;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -5px; /* Centrado */
}

/* Puntero del Input Range - Firefox */
.custom-range::-moz-range-thumb {
  height: 16px;
  width: 16px;
  background: white;
  border: 1px solid #00000073;
  border-radius: 50%;
  cursor: pointer;
}
</style>